import travelAIPhoto from '../../Assets/Gallery/travel_ai_tshirt_photo.jpeg';
import genuityBanglaNewYear from '../../Assets/Gallery/akashgenuity.jpg';
import championProjectShowcaseIIT from '../../Assets/Gallery/champion_project_showcase.JPG';
import bashundharaw3Hoodie from '../../Assets/Gallery/bashundhara_with_hoodie.jpg';
import metroplexTrophy from '../../Assets/Gallery/metroplex_with_trophy.jpg';
import bananiTravelAITshirt from '../../Assets/Gallery/Banani_office_desk_travel_ai_tshirt.jpg';
import w3MugDesk from '../../Assets/Gallery/w3_mug_desk.jpg';
import w3DataTeamTravelAItshirt from '../../Assets/Gallery/w3_data_team_travelai_tshirt.jpg';
import bananiRounRestPlace from '../../Assets/Gallery/round_rest_place_banani.jpg';
import firstDayAtGenuity from '../../Assets/Gallery/first_day_at_genuity.jpg';
import genuityBanglaNewYearGroupPic from '../../Assets/Gallery/genuity_bangla_new_year.jpg';
import finalYearProjectDefense from '../../Assets/Gallery/FYP_presentation.jpg';
import finalYearProjectDefensezsingle from '../../Assets/Gallery/fyp_project_day.jpg';
import wooxpertoDesk from '../../Assets/Gallery/wooxperto_desk.jpg';
import w3PithaUtsob from '../../Assets/Gallery/w3_pitha_utsob.jpg';
import projectshowcaseCertificate from '../../Assets/Gallery/project_showcase_champion_certificate.jpg';
import firstDayAtW3 from '../../Assets/Gallery/first_day_at_w3engineers.jpg';
import airtelProjectGenuity from '../../Assets/Gallery/airtel_robi_project_at_genuity.jpg';
import pictureWithTeachersMIET from '../../Assets/Gallery/Picture with Teachers MIET 2022.jpg';
import closingMIET2022 from '../../Assets/Gallery/MIET 2022 Closing.jpg';
import agift_office_desk from '../../Assets/Gallery/agift_office_desk.jpeg';

export const photos = [
    {
      src: travelAIPhoto,
      width: 2044,
      height: 1536
    },
    {
      src: agift_office_desk,
      width: 800,
      height: 792
    },
    {
      src: bananiTravelAITshirt,
      width: 3076,
      height: 4096
    },
    {
      src: championProjectShowcaseIIT,
      width: 5472,
      height: 3648
    },
    {
      src: bashundharaw3Hoodie,
      width: 3076,
      height: 4096
    },
    {
      src: metroplexTrophy,
      width: 3072,
      height: 4096
    },
    {
      src: genuityBanglaNewYear,
      width: 1048,
      height: 1310
    },
    {
      src: w3MugDesk,
      width: 3456,
      height: 4608
    },
    {
      src: w3DataTeamTravelAItshirt,
      width: 3368,
      height: 1989
    },
    {
      src: bananiRounRestPlace,
      width: 4096,
      height: 2932
    },
    {
      src: airtelProjectGenuity,
      width: 865,
      height: 1121
    },
    {
      src: firstDayAtGenuity,
      width: 960,
      height: 960
    },
    {
      src: genuityBanglaNewYearGroupPic,
      width: 2048,
      height: 1536
    },
    {
      src: finalYearProjectDefensezsingle,
      width: 4928,
      height: 6560
    },
    {
      src: finalYearProjectDefense,
      width: 3316,
      height: 2490
    },
    {
      src: wooxpertoDesk,
      width: 4009,
      height: 2304
    },
    {
      src:projectshowcaseCertificate,
      width: 3867,
      height: 2801
    },
    {
      src: w3PithaUtsob,
      width: 2908,
      height: 4027
    },
    {
      src: pictureWithTeachersMIET,
      width: 1080,
      height: 1199
    },
    {
      src: closingMIET2022,
      width: 1080,
      height: 942
    },
    {
      src: firstDayAtW3,
      width: 4608,
      height: 3456
    }
  ];
  